import { NativeEventEmitter, NativeModules, Platform } from 'react-native';

export interface AndroidDisplayInfo {
  displayId: number;
  name: string;
  flags: number;
  width: number;
  height: number;
  isPrimary: boolean;
  isCurrent: boolean;
}

interface SecondaryDisplayModuleInterface {
  initialize(): Promise<number>;
  getAllDisplays(): Promise<AndroidDisplayInfo[]>;
  getSecondaryDisplays(): Promise<
    Pick<AndroidDisplayInfo, 'displayId' | 'name' | 'flags'>[]
  >;
  getCurrentDisplayId(): Promise<number>;
  moveToSecondaryDisplay(): Promise<number>;
  moveToDisplay(displayId: number): Promise<number>;
  dismissPresentation(): Promise<boolean>;
  canDrawOverlays(): Promise<boolean>;
  requestDrawOverlays(): Promise<boolean>;
}

const SecondaryDisplayModule: SecondaryDisplayModuleInterface | null =
  Platform.OS === 'android' ? NativeModules.SecondaryDisplayModule : null;

const emitter =
  Platform.OS === 'android' && SecondaryDisplayModule
    ? new NativeEventEmitter(NativeModules.SecondaryDisplayModule)
    : null;

export function initializeSecondaryDisplay(): Promise<number> {
  if (!SecondaryDisplayModule) return Promise.resolve(0);
  return SecondaryDisplayModule.initialize();
}

export function getAllDisplays(): Promise<AndroidDisplayInfo[]> {
  if (!SecondaryDisplayModule) return Promise.resolve([]);
  return SecondaryDisplayModule.getAllDisplays();
}

export function getCurrentDisplayId(): Promise<number> {
  if (!SecondaryDisplayModule) return Promise.resolve(0);
  return SecondaryDisplayModule.getCurrentDisplayId();
}

export function moveToSecondaryDisplay(): Promise<number> {
  if (!SecondaryDisplayModule) return Promise.resolve(0);
  return SecondaryDisplayModule.moveToSecondaryDisplay();
}

export function moveToDisplay(displayId: number): Promise<number> {
  if (!SecondaryDisplayModule) return Promise.resolve(0);
  return SecondaryDisplayModule.moveToDisplay(displayId);
}

export function dismissPresentation(): Promise<boolean> {
  if (!SecondaryDisplayModule) return Promise.resolve(false);
  return SecondaryDisplayModule.dismissPresentation();
}

export function canDrawOverlays(): Promise<boolean> {
  if (!SecondaryDisplayModule) return Promise.resolve(false);
  return SecondaryDisplayModule.canDrawOverlays();
}

export function requestDrawOverlays(): Promise<boolean> {
  if (!SecondaryDisplayModule) return Promise.resolve(false);
  return SecondaryDisplayModule.requestDrawOverlays();
}

export function onSecondaryDisplayAdded(
  callback: (displayId: number) => void,
): () => void {
  if (!emitter) return () => {};
  const sub = emitter.addListener('onSecondaryDisplayAdded', callback);
  return () => sub.remove();
}

export function onSecondaryDisplayRemoved(
  callback: (displayId: number) => void,
): () => void {
  if (!emitter) return () => {};
  const sub = emitter.addListener('onSecondaryDisplayRemoved', callback);
  return () => sub.remove();
}
